import courseData from "./courses.json";

export interface Course {
  id: string;
  slug: string | null;
  path?: string;
  title: string;
  subtitle: string;
  category: string;
  cover_url: string;
  cover_position: string | null;
  is_free: boolean;
  price_rub: number | null;
  created_at: string;
  blocks: {
    hero: { title?: string; category?: string; subtitle?: string; cover_url?: string };
    text_image: {
      title: string;
      image_url?: string;
      image_side?: string;
      paragraphs: { heading?: string; body: string }[];
    };
    feature_grid: { title: string; items: { text: string; icon_url?: string }[] };
    numbered_list: { title: string; items: string[] };
    program: { title: string; modules: { title: string; lessons: { title: string; duration?: string }[] }[] };
    faq: { title: string; items: { q: string; a: string }[] };
  };
}

export const courses = courseData as Course[];

export const coursePath = (course: Course) => course.path || `/education/courses/${course.slug || course.id}`;
export const sourceCourseUrl = (course: Course) => `https://transformation.wmtunnel.ru/course/${course.slug || course.id}`;
export const purchaseUrl = (course: Course) => `https://ii-agent.ru/korzina/?course=${encodeURIComponent(course.slug || course.id)}`;
export const coursePrice = (course: Course) => course.is_free ? "Бесплатно" : `${new Intl.NumberFormat("ru-RU").format(course.price_rub || 0)} ₽`;
